<template>
  <div>
    <h4 :class="props.titleclass">Unsere Geschäftsstelle</h4>
    <p class="mb-2"><i class="fa fa-map-marker-alt me-3"></i>Reutlingen, DE</p>
    <p class="mb-2"><i class="fa fa-phone-alt me-3"></i>+49 173 9726335</p>
    <p class="mb-2">
      <i class="fa fa-envelope me-3"></i>halimi.gazi@outlook.de
    </p>
    <p class="mb-2">
      <i class="fa fa-envelope me-3"></i>gartenbau.gazi@gmail.com
    </p>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
const props = defineProps({
  titleclass: { type: String, default: 'mb-4' },
});
</script>
